import { Permission } from "@/types/permission";
import { BuilderElementControls } from "@/types/elements";

export function getPermission(permissions: Permission[], permission: string) {
  return permissions.find(p => p.slug === permission);
}

export function filterControlsThatCanBeModified(
  controls: BuilderElementControls,
  permission: Permission | null
) {
  if (permission?.slug === "full") {
    return controls;
  }

  return {
    ...controls,
    designSections: [],
    settingsSections: []
  };
}
